import { usePrograms } from '@/lib/hooks'
import { ProgramsGrid } from '@/components/sections/ProgramsGrid'
import { PageHero } from '@/components/layout/PageHero'

export function ProgramsPage() {
  const { data: programs = [] } = usePrograms()
  return (
    <>
      <PageHero
        eyebrow="Player Pathways"
        title="All Programs."
        intro="Ten tiered programs — Recreation through Elite, plus International Tours, Private Coaching, the Jamaica Development Recreation Football Program, and College Placement pathway."
        image="https://cosmosfc.org/wp-content/uploads/2022/03/jj07-1024x682.jpg"
        crumbs={[{ label: 'Programs' }]}
      />
      <section className="py-20">
        <div className="container-narrow">
          <ProgramsGrid programs={programs} />
        </div>
      </section>
    </>
  )
}
